var React = require('react');

function BluelineTop2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M800 0H0V10V81C10.486 18.3993 156.872 17.629 420.369 16.2426C527.852 15.6771 654.82 15.009 800 10V0Z","fill":"#3290FF"}));
}

BluelineTop2.defaultProps = {"width":"800","height":"81","viewBox":"0 0 800 81","preserveAspectRatio":"none","fill":"none"};

module.exports = BluelineTop2;

BluelineTop2.default = BluelineTop2;
